import { render, staticRenderFns } from "./tprConfigAdd.vue?vue&type=template&id=4f0e67ea&"
import script from "./tprConfigAdd.vue?vue&type=script&lang=js&"
export * from "./tprConfigAdd.vue?vue&type=script&lang=js&"
import style0 from "./tprConfigAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports